module.exports = __webpack_public_path__ + "static/media/job-order-transparent.52d3b622.svg";